import { render, staticRenderFns } from "./blackWarehouseIcon.vue?vue&type=template&id=54c824f2&scoped=true"
import script from "./blackWarehouseIcon.vue?vue&type=script&lang=js"
export * from "./blackWarehouseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c824f2",
  null
  
)

export default component.exports